module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"calendarHelp":{"howDoesThisWork":"How does this work?"}}}')
  delete Component.options._Ctor
}
